import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { EGiftDenomination } from "src/app/shared/models/eGift/EGiftDenomination.model";
import { EGiftVenue } from "src/app/shared/models/eGift/EGiftVenue.model";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { v4 as uuidv4 } from "uuid";

@Component({
	selector: "app-e-gift-card-denomination-setup",
	templateUrl: "./e-gift-card-denomination-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class EGiftCardDenominationSetupComponent implements OnInit, OnDestroy {
	@Input() denominations: EGiftDenomination[];
	@Input() eGiftVenue: EGiftVenue;
	@Output() denominationEmitter: EventEmitter<EGiftDenomination[]> = new EventEmitter<EGiftDenomination[]>();

	denominationSelected: EGiftDenomination;

	moment: any = moment;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {
		this.denominations.forEach((i) => {
			if (i.expirationDate) {
				i.expirationDate = new Date(i.expirationDate);
			}
		});
		this.denominationSort();
	}

	ngOnDestroy() {
		this.denominationEmitter.emit(this.denominations);
		this.save();
	}

	async new() {
		this.denominationSelected = new EGiftDenomination({
			key: uuidv4(),
			venueKey: this.venueSvc.venueKey,
			unsaved: true,
		});
	}

	async save(rec?: EGiftDenomination) {
		if (rec) {
			rec.unsaved = false;
			await this.focuslink.eGiftDenominationPost(this.venueSvc.venueKey, rec);
			this.denominationSelected = undefined;
			if (rec && this.denominations.some((i) => i.key === rec.key)) {
				const idx = this.denominations.findIndex((i) => i.key === rec.key);
				this.denominations[idx] = rec;
			} else {
				this.denominations.push(rec);
			}

			this.denominationSort();
		}

		await this.focuslink.eGiftDenominationPost(this.venueSvc.venueKey, this.denominations);
		await this.focuslink.eGiftVenuePost(this.venueSvc.venueKey, this.eGiftVenue);
	}

	denominationSort() {
		this.denominations.sort((a, b) => {
			if (a.sortVal === b.sortVal) {
				return a.value - b.value;
			} else {
				return a.sortVal < b.sortVal ? -1 : 1;
			}
		});
	}

	async deleteDenomination(denomination: EGiftDenomination) {
		await this.focuslink.eGiftDenominationDelete(this.venueSvc.venueKey, denomination.value);
		this.denominations.splice(
			this.denominations.findIndex((i) => i.value === denomination.value),
			1
		);
		this.denominationSelected = undefined;
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `${denomination.value} has been deleted.` });
	}
}
